import * as React from "react";

import { IsRequiredValidation } from "@generation/form";
import { useTranslation } from "@i18n/iprox";

import { useNaarWaarheidIngevuldContext } from "../context/NaarWaarheidIngevuldContextProvider";

let naarWaarheidIngevuldGlobalStateHelper = false;
export const getNaarWaarheidIngevuld = () => {
  return naarWaarheidIngevuldGlobalStateHelper;
};

let showValidationMessageCallbackGlobalHelper: ((showValidationMessage: boolean) => void) | null = null;
export const getShowValidationMessageCallback = () => {
  return showValidationMessageCallbackGlobalHelper;
};

export interface NaarwaarheidIngevuldSchemaModel {
  naarWaarheidIngevuld: {
    naarWaarheidIngevuld: string;
  };
}

export const NaarWaarheidIngevuld = (props: { namespace: string }) => {
  const context = useNaarWaarheidIngevuldContext();
  const { t } = useTranslation(props.namespace);

  const validator = new IsRequiredValidation(false);

  const naarWaarheidIngevuldLabel = t("fields.overzichtSection.naarWaarheidIngevuld.label");
  const errorMessage = validator.defaultMessage(naarWaarheidIngevuldLabel);

  React.useEffect(() => {
    naarWaarheidIngevuldGlobalStateHelper = context.naarWaarheidIngevuld;

    if (context.naarWaarheidIngevuld) {
      context.setFoutmelding(undefined);
    }
  }, [context.naarWaarheidIngevuld]);

  showValidationMessageCallbackGlobalHelper = React.useCallback(
    (showValidationMessage: boolean) =>
      showValidationMessage ? context.setFoutmelding(errorMessage) : context.setFoutmelding(undefined),
    [context]
  );

  return (
    <form>
      <div className="d-flex flex-row">
        <label htmlFor="naar-waarheid-ingevuld">
          <input
            id="naar-waarheid-ingevuld"
            type="checkbox"
            name="naar-waarheid-ingevuld"
            checked={context.naarWaarheidIngevuld}
            onChange={(_event) => {
              const newState = !context.naarWaarheidIngevuld;
              context.setNaarWaarheidIngevuld(newState);
              naarWaarheidIngevuldGlobalStateHelper = newState;
            }}
          />
          &nbsp; {naarWaarheidIngevuldLabel}
        </label>
      </div>
      <div className="error-text text-danger mt-2">{context.foutmelding}</div>
    </form>
  );
};
